// src/components/AddCompanyForm/ActionBar.jsx
import React from "react";
import { Box, Button } from "@mui/material";

export default function ActionBar({ onClose, isFetching, disabled, children }) {
  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        zIndex: 10,
        mt: 2,
        p: 1,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        justifyContent: "flex-end",
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        boxShadow: 3,
        bgcolor: "background.paper",
      }}
    >
      <Box sx={{ mr: "auto", fontSize: 13, color: "text.secondary" }}>{children}</Box>
      <Button variant="outlined" onClick={onClose} disabled={isFetching}>
        Cancelar
      </Button>
      <Button type="submit" variant="contained" disabled={isFetching || disabled}>
        {isFetching ? "Salvando..." : "Salvar"}
      </Button>
    </Box>
  );
}
